import * as React from "react";

import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md bg-white px-3 py-2 text-base text-neutral-950 shadow-xs ring-1 ring-neutral-950/10 outline-none placeholder:text-neutral-400 focus-visible:outline-2 -outline-offset-1 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-50 sm:h-9 sm:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
);

Input.displayName = "Input";
